import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.css'
import "./assets/styles/styles.css"
 import "./assets/styles/adminlte.css"
 import "./assets/styles/adminlte.min.css"
import AOS from 'aos'
import 'aos/dist/aos.css'

import formatDate from './filters/format-date'
Vue.use(formatDate)

import formatDateTime from './plugins/formatDateTime'
Vue.use(formatDateTime)

import numbers from "./filters/numbers"
Vue.use(numbers)

import msg from '@/plugins/msg'
Vue.use(msg)

import { BootstrapVueIcons } from 'bootstrap-vue'
 import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

 import * as VueGoogleMaps from "vue2-google-maps";

 import VueHtml2Canvas from 'vue-html2canvas';
 

 Vue.use(BootstrapVueIcons)

Vue.use(VueHtml2Canvas);

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBySfJg_N6hj9O_FvUkm5sOSVO72w2MrIw",
    libraries: 'places',
  },
});

new Vue({
  data: {
    clienteID: 0,
    numeroCliente: '',
    usuario: '',
    pass:'',
    nombres:''
  },
  router,
  store,
  render: h => h(App),
  // watch:{
  //   '$route' (to) {
  //      if(to.currentRoute.meta.reload==true){window.location.reload()}
  // }},
  mounted () {
    if (localStorage.clienteID){
      this.clienteID = localStorage.clienteID;
    }
  if (localStorage.token){
      this.token = localStorage.token;
    }
    if (localStorage.usuario){
      this.usuario = localStorage.usuario;
    }
    if (localStorage.numeroCliente){
      this.numeroCliente = localStorage.numeroCliente;
    }
    if (localStorage.pass){
      this.pass = localStorage.pass;
    }
    if (localStorage.nombres){
      this.pass = localStorage.nombres;
    }
    AOS.init()},
    methods: {
      persist() {
        localStorage.idCliente =  this.idCliente;
        localStorage.usuario = this.usuario
        localStorage.numeroCliente = this.numeroCliente
        localStorage.pass = this.pass
        localStorage.nombres = this.nombres
      }
    },
}).$mount('#app')
